const sortingFunctions = {
    'name-desc': (current, next) => (current.getName().toLowerCase() > next.getName().toLowerCase()) ? -1 : 1,
    'name-asc': (current, next) => (current.getName().toLowerCase() < next.getName().toLowerCase()) ? -1 : 1
};

export default sortingFunctions;